export const DISABLE_USER = 'Disable User';
export const ENABLE_USER = 'Enable User';
export const DISABLE_USER_CONFIRMATION = 'Disable user confirmation';
export const ENABLE_USER_CONFIRMATION = 'Enable user confirmation';

export const PASSWORD_STATUS = {
  USABLE: 'Usable',
  UNUSABLE: 'Unusable',
};
